import { Activity, AlertTriangle, BarChart3, ClipboardList, FileCheck2, Plus, Spline, TreeDeciduous } from 'lucide-react';
import { agruparSecciones, GRUPOS } from 'components/ui/agruparSecciones';

// Menú de la app por rol (admin | editor | viewer), agrupado con la convención
// de shared/vls-ui (2026-10-20): máximo 4 entradas en la fila, Estado suelto y
// los grupos de nombre fijo Operación / Reportes. Desde el 2026-10-22 (Isaac) NO hay
// grupo Gestión: Cables y Árboles son las dos entradas sueltas de la fila (los datos
// de la app, no configuración), y Estado va dentro de Operación para quedar en 4
// entradas (2 sueltas + 2 grupos). La cuenta del PIN
// no ve menú (solo inspecciona y sale); la tablet del kiosco ve lo de su rol y
// además Nueva inspección. Mismas rutas y mismos roles que antes.
export const NAV_GROUPS = [
  { label: GRUPOS.operacion.label, grupo: 'operacion', icon: ClipboardList, items: [
    { label: 'Estado', path: '/estado', icon: Activity, tooltip: 'Cómo están hoy las instalaciones', roles: ['viewer', 'editor', 'admin'] },
    { label: 'Nueva inspección', path: '/inspeccion', icon: Plus, tooltip: 'Registrar la inspección diaria', roles: ['editor', 'admin'], kiosco: true },
    { label: 'Hallazgos', path: '/hallazgos', icon: AlertTriangle, tooltip: 'Ítems en alerta o falla', roles: ['viewer', 'editor', 'admin'] },
  ] },
  { label: GRUPOS.reportes.label, grupo: 'reportes', icon: BarChart3, items: [
    { label: 'Inspecciones', path: '/inspecciones', icon: ClipboardList, tooltip: 'Historial de inspecciones', roles: ['viewer', 'editor', 'admin'] },
    { label: 'Reportes', path: '/reportes', icon: FileCheck2, tooltip: 'Reporte de inspecciones por período', roles: ['viewer', 'editor', 'admin'] },
  ] },
];

// Entradas sueltas de la fila, antes de los grupos (máximo 2 por la convención de shared).
export const NAV_SUELTOS = [
  { label: 'Cables', path: '/cables', icon: Spline, tooltip: 'Fichas, inspecciones y mantenimiento de los cables', roles: ['viewer', 'editor', 'admin'] },
  { label: 'Árboles', path: '/arboles', icon: TreeDeciduous, tooltip: 'Fichas y evaluaciones de los árboles', roles: ['viewer', 'editor', 'admin'] },
];
export const SUELTAS = NAV_SUELTOS.map((i) => i.path);

// Nueva inspección: editor, admin y la tablet del kiosco. Viewer no.
export const puedeInspeccionar = ({ role, esKiosco } = {}) => !!esKiosco || role === 'admin' || role === 'editor';

const ve = (item, { role, esKiosco }) => item.roles.includes(role) || (!!item.kiosco && !!esKiosco);

export const gruposParaRol = (role, { esKiosco = false, esPin = false } = {}) => {
  if (esPin) return [];
  return NAV_GROUPS
    .map((g) => ({ ...g, items: g.items.filter((i) => ve(i, { role, esKiosco })) }))
    .filter((g) => g.items.length > 0);
};

export const sueltasParaRol = (role, { esKiosco = false, esPin = false } = {}) => {
  if (esPin) return [];
  return NAV_SUELTOS.filter((i) => ve(i, { role, esKiosco }));
};

export const estaActivo = (item, pathname = '') =>
  item.exact
    ? pathname === item.path
    : pathname === item.path || pathname.startsWith(item.path + '/');

// Secciones del encabezado común (AppHeader, copia de shared/vls-ui): la misma
// lista de gruposParaRol en el formato que pide el componente, con su `grupo`,
// para agruparSecciones. La cuenta del PIN no recibe ninguna.
export const seccionesPlanasParaRol = (role, opts) => [
  ...sueltasParaRol(role, opts).map((i) => ({ label: i.label, to: i.path, icon: i.icon, title: i.tooltip, exact: !!i.exact })),
  ...gruposParaRol(role, opts).flatMap((g) => g.items.map((i) => ({
    label: i.label, to: i.path, icon: i.icon, title: i.tooltip, exact: !!i.exact, grupo: g.grupo,
  }))),
];

export const seccionesParaRol = (role, opts) => agruparSecciones(seccionesPlanasParaRol(role, opts), { sueltas: SUELTAS });
